import { render, staticRenderFns } from "./workflowHrNewEmployeeTable.vue?vue&type=template&id=5fe93c95"
import script from "./workflowHrNewEmployeeTable.vue?vue&type=script&lang=js"
export * from "./workflowHrNewEmployeeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports